import { Component, Inject, OnInit, OnDestroy, Optional } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { StartupService } from '@core';
import { ReuseTabService } from '@delon/abc/reuse-tab';
import { DA_SERVICE_TOKEN, ITokenService, SocialOpenType, SocialService } from '@delon/auth';
import { SettingsService, _HttpClient } from '@delon/theme';
import { environment } from '@env/environment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzTabChangeEvent } from 'ng-zorro-antd/tabs';
import { AccountService } from 'src/app/modules/service/account/account.service';
import { CommonService } from 'src/app/modules/service/common/common.service';
import { LoginService } from 'src/app/modules/service/login/login.service';

@Component({
  selector: 'passport-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.less'],
  providers: [SocialService],
})
export class LoadingComponent implements OnInit, OnDestroy {
  constructor(
    fb: FormBuilder,
    private router: Router,
    private settingsService: SettingsService,
    private socialService: SocialService,
    @Optional()
    @Inject(ReuseTabService)
    private reuseTabService: ReuseTabService,
    @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
    private startupSrv: StartupService,
    public http: _HttpClient,
    public msg: NzMessageService,
    private message: NzMessageService,
    private loginService: LoginService,
    private common: CommonService,
    private activatedRoute: ActivatedRoute,
  ) {}
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      // console.log(queryParams);
      if (queryParams.code != undefined) {
        this.loginService
          .oauth({
            code: queryParams.code,
            state: queryParams.state,
          })
          .then((res) => {
            if (res.access_token == undefined) {
              sessionStorage.setItem('oauth_id', res.oauth_id);
              this.router.navigate(['/passport/password-set'], {
                queryParams: {
                  type: 3,
                },
              });
            } else {
              this.tokenService.set({ token: res['access_token'] });
              this.common.setCache('userInfo', res);
              this.loginService.getMenuRoles().then((menu) => {
                this.common.setCache('menuRole', menu);
                this.router.navigate(['/home']).then();
              });
            }
          });
      }
    });
  }
  ngOnDestroy(): void {}
}
